
import Map from 'ol/Map';
import * as ol_style from 'ol/style';
import Feature from 'ol/Feature';
import Polygon from 'ol/geom/Polygon';
import { Vector as ol_layer_Vector } from 'ol/layer';
import { Vector as ol_source_Vector } from 'ol/source';
import { Point as ol_geom_Point } from 'ol/geom';
import MultiPoint from 'ol/geom/MultiPoint';
import { Circle as CircleStyle, Fill, RegularShape, Stroke, Style, Text } from 'ol/style';

import { FrCoordinate, FrLayer } from 'gmap';
import { SupervisionError, Panel, SupervisionErrorStatusEnum } from 'solar-bo';

import { MapSupervisionHelper } from './map-supervision-helper';
import { DBColumnsEnum, IDB_filter } from 'solar-bo';
import IconOrigin from 'ol/style/IconOrigin';
import IconAnchorUnits from 'ol/style/IconAnchorUnits';
import { getTopLeft } from 'ol/extent';
import { IItemDrawConfig } from 'gmap';
import { IFilterItemCollection } from '@solar/solar/dashboard/db-filter/filter';


export class MapSupervisionIssues {

  /**
 * filters selected to show issues in lists and maps
 */
  filterSelected: IFilterItemCollection[] = [];
  panelStyle: any[] = [];
  filter_status: SupervisionErrorStatusEnum = SupervisionErrorStatusEnum.none;
  /**
   * True to indicate that panels are in validation mode so we show panels based on status
   */
  validationMode:boolean=false;
  // map:Map;
  constructor() {
    //   this.map=mapc.map;
    this.configurePanelStyle();
  }

  panelFillDefault: any;
  panelFillDefaultValidated: any;
  /**
   * cache stroke, fills, etc
   */
  issueCacheDrawOptions: IItemDrawConfig[] = [];

  configurePanelStyle() {
    this.panelFillDefault = new Fill({
      color: 'rgba(220, 53, 53, 0.2)'
    });
    this.panelFillDefaultValidated = new Fill({
      color: 'rgba(162, 238, 166, 0.8)'
    });   

    /*     let stroke = new ol_style.Stroke({
          color: this.issueGetErrorTypeColor(issue.type),
          width: 2
        }); */
  }
  

  issueNameStroke = new ol_style.Stroke({
    color: [255, 255, 255, 1],
    width: 4
  });

  issueNamefill = new ol_style.Fill({
    color: [0, 0, 0, 1]
  });
  /**
   * Style for issues
   * @param feature 
   * @param resolution 
   */
  panelsFilterStyle(feature, resolution) {

    try {
      //let geom = feature.getGeometry();
      const extInfo: FrLayer = feature.frlayerinfo;
      let issue: SupervisionError = extInfo.refObject;

      if (this.filter_status != SupervisionErrorStatusEnum.none) {
        if (issue.info.status != this.filter_status) {
          return null;
        }
      }

      let existInFilter = this.panelFilterCompare(DBColumnsEnum.issue_type, issue.type);
      if (existInFilter == false) {
        return null;
      }

      existInFilter = this.panelFilterCompare(DBColumnsEnum.relevance, issue.info.relevance);
      if (existInFilter == false) {
        return null;
      }
      
      existInFilter = this.panelFilterCompare(DBColumnsEnum.relevance, issue.info.relevance);
      if (existInFilter == false) {
        return null;
      }
      

      let panel: Panel = issue.info.panel;
      if (panel) {
        let panelType: any = panel.panelType;
        if (panelType) {
          existInFilter = this.panelFilterCompare(DBColumnsEnum.panel_brand, panelType.brand);
          if (existInFilter == false) {
            return null;
          }

          existInFilter = this.panelFilterCompare(DBColumnsEnum.panel_model, panelType.model);
          if (existInFilter == false) {
            return null;
          }
        }
      }

      let issueDrawCfg: IItemDrawConfig;
      let panelFill=this.panelFillDefault;
      if (this.validationMode){
        issueDrawCfg=this.getIssueDrawConfiguration(issue);
        if (issue.info.status==SupervisionErrorStatusEnum.validated){
          panelFill=this.panelFillDefaultValidated;
        }
        else if (issue.info.status==SupervisionErrorStatusEnum.tovalidate){
          panelFill=this.panelFillDefault;

        }
      }
      else{
        issueDrawCfg=this.getIssueDrawConfiguration(issue);
        panelFill=this.panelFillDefault;
      }
   
      
      let title = feature.frlayerinfo.name + " \n " + issue.type;
      let scaleSize = 0.9;// Math.floor(resolution * 10000000000);

      /*       if (resolution <1e-8) {
              scaleSize = 0.4;
            } else if (resolution <1e-7) {
              scaleSize = 0.6;
            }
      
            console.log(resolution + " " + scaleSize); */
      /* let strokeText = new ol_style.Stroke({
        color: issueColor,
        width: 6
      }); */

      /*       let strokeText1 = new ol_style.Stroke({
              color: [255, 255, 255, 0.8],
              width: 4
            }); */

      let textStyle = new ol_style.Text({
        text: title
        , font: 'bold 11px Calibri,sans-serif'
        , scale: scaleSize
        , fill: this.issueNamefill,
        stroke: this.issueNameStroke
      })

      let style1 = new ol_style.Style({
        stroke: issueDrawCfg.stroke
        , fill: panelFill
        , text: textStyle
      });
      /*       let textStyle2=new ol_style.Text({
              text: issue.type
              ,offsetY: 20
              ,scale: 1.3
              , fill : new Fill({
                color: issueColor
              })
              ,stroke: strokeText 
            })
            let style2=new ol_style.Style({       
               text:textStyle2
               
            }); */

      let styles = [style1];

      return styles;
    }
    catch (err) {
      console.log(err);
    }
  }

  private getIssueDrawConfiguration(issue: SupervisionError) {
    let issueColor = MapSupervisionHelper.issueGetErrorTypeColor(issue.type);
    let itemDrawOptions = this.issueCacheDrawOptions.find(item => item.key === issueColor);
    let strokeFor: any;
    if (itemDrawOptions) {      
      return itemDrawOptions;
    }
    else {
      strokeFor = new ol_style.Stroke({
        color: issueColor,
        width: 2
      });
      itemDrawOptions={ key: issueColor, stroke: strokeFor,fill:this.panelFillDefault };
      this.issueCacheDrawOptions.push(itemDrawOptions);

    }
    return itemDrawOptions;
  }



  panelFilterCompare(filter: string, value: any): boolean {
    let filtersType = this.filterSelected.find(elem => elem.id_filter == filter);
    if (filtersType) {
      let values: any[] = filtersType.value;
      let elemExist = values.find(elem => elem == value);
      if (elemExist) {
        return true;
      } else {
        return false;
      }
    }
  }


  mapIssueSelectedPanelStyle(feature, resolution, issueSelected:SupervisionError,options?:any ) {
    //console.log("mapIssueSelectedPanelStyle",feature,resolution);
    let geom = feature.getGeometry();
    let issue = feature.frlayerinfo.refObject;
    /* if (issue.id=="8a09fcba-bf7c-11ea-91d6-509a4c837ab7"){
      console.log("mapIssueSelectedPanelStyle stop");
    } */
    let stroke = new ol_style.Stroke({
      color: MapSupervisionHelper.issueGetErrorTypeColor(issue.type),
      width: 0.5
    });

    let panelIcon:ol_style.Icon;
    panelIcon = new ol_style.Icon(({
      color: MapSupervisionHelper.issueGetErrorTypeColor(issue.type),
      crossOrigin: 'anonymous'
      , src: 'assets/ol/marker3a.png'
      , scale: 1
      , anchor: [0.5, 0]
      , anchorOrigin: IconOrigin.BOTTOM_LEFT
      , anchorXUnits: IconAnchorUnits.FRACTION
      , anchorYUnits: IconAnchorUnits.PIXELS
    }));

    let styles = [];


    let styleBorders = new ol_style.Style({
      stroke: stroke,
      fill: this.panelFillDefault
    });

    styles.push(styleBorders);


    if (issueSelected && issueSelected.id == issue.id) {
      let styleIcon = new ol_style.Style({
        image: panelIcon
        , geometry: function (tfeature) {
          let anchorPoint = getTopLeft(tfeature.getGeometry().getExtent());
          return new ol_geom_Point(anchorPoint);
        }
      });
      styles.push(styleIcon);
    }


    return styles;
  }

}